import React from 'react';
import PropTypes from 'prop-types';

/*
 * Get these from word press like this
 * http https://www.communityshare.org/wp-json/wp/v2/media/2766 | jq '{id, src: .media_details.sizes.thumbnail.source_url, alt: .alt_text}'
 * where "2766" is the image id
 */
const DEFAULT_LOGOS = [
  {
    "id": 2721,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/pima-150x150.png",
    "alt": "Pima County School Superintendent Logo"
  },
  {
    "id": 2717,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/ednium-150x150.png",
    "alt": "Ednium Alumni Collective Logo"
  },
  {
    "id": 2977,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/10/fyi-150x150.png",
    "alt": "FYI+ Logo"
  },
  {
    "id": 2718,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/flagstaff-150x150.png",
    "alt": "Flagstaff Unified School District Logo"
  },
  {
    "id": 2713,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/bcps-150x150.png",
    "alt": "Bullitt County Public Schools"
  },
  {
    "id": 2693,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/crosstown-300x102.png",
    "alt": "Crosstown"
  },
  {
    "id": 2723,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/sycamore-150x150.png",
    "alt": "Sycamore Community Schools Logo"
  },
  {
    "id": 2975,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/10/aim-150x150.png",
    "alt": "Academy for Innovation in Medicine logo"
  },
  {
    "id": 2712,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/wps-150x150.png",
    "alt": "WPS Institute Logo"
  },
  {
    "id": 2888,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/07/wnc-resilience-project-logo-150x150.png",
    "alt": "WNC Resilience Project Logo"
  },
  {
    "id": 2876,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/07/babcock-schools-150x150.png",
    "alt": "babcock-schools logo"
  },
  {
    "id": 2714,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/cochise-150x150.png",
    "alt": "Cochise ESA Logo"
  },
  {
    "id": 2974,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/10/pinal-county-150x150.png",
    "alt": "Pinal County School Office logo"
  },
  {
    "id": 2766,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/02/tewksbury-150x150.png",
    "alt": ""
  },
  {
    "id": 2690,
    "src": "https://www.communityshare.org/wp-content/uploads/2025/12/03-046-24-pas_communityschoolspartnershipsbranding_graphics-150x150.png",
    "alt": "Riverside County Office of Education"
  },
  {
    "id": 2768,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/02/watershed-150x150.png",
    "alt": "watershed school logo"
  },
  {
    "id": 2767,
    "src": "https://www.communityshare.org/wp-content/uploads/2026/02/andover-2-150x150.png",
    "alt": "Andover Public Schools Massachusetts"
  }
]
LogoCell.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string
};

function LogoCell(props) {
  const { src, alt } = props;

  return (
    <div className="w-32 h-20 bg-white rounded-cs-10 flex items-center justify-center p-3 overflow-hidden">
      {src ? (
        <img src={src} alt={alt ?? ''} title={alt} className="w-full h-full object-contain"/>
      ) : (
        <div className="w-8 h-6 bg-cs-gray-200 rounded"/>
      )}
    </div>
  );
}

NetworkLogos.propTypes = {
  title: PropTypes.node,
  logos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    alt: PropTypes.string
  }))
};

export default function NetworkLogos(props) {
  const {
    title = 'Our network members include',
    logos = DEFAULT_LOGOS
  } = props;

  return (
    <div className="w-full max-w-screen-xl mx-auto">
      <p className="text-sm font-semibold text-cs-gray-500 mb-4">{title}</p>
      <div className="flex flex-row flex-wrap justify-center gap-4">
        {logos.map((logo, i) => (
          <LogoCell key={logo.id ?? i} src={logo.src} alt={logo.alt}/>
        ))}
      </div>
    </div>
  );
}
